const analyticsApi = () => {
  const validate = (trackedData, analyticsFunction) => {
    if (typeof dataLayer === "undefined" || !trackedData) {
      return;
    }
    return analyticsFunction(trackedData);
  };

  const generateAnalyticsAddToCart = (trackedData = {}) => {
    const dataLayerObject = {
      event: "add_to_cart",
      ecommerce: {
        currency: "EUR",
        //Apartment rent / cost-unit rents between, Area price level.
        value:
          trackedData?.rent ??
          trackedData?.rents?.costunit ??
          trackedData?.price_level ??
          null,
        items: [
          {
            item_name: trackedData?.address ?? trackedData?.name, //Apartment address or Costunit Address or area name
            item_id: trackedData?.analyticsType, //The analytics-type of the object cost-units, apartments, areas
            item_category: trackedData?.city, //City field
            item_category2: trackedData?.area ?? trackedData?.name, // Area-field
            item_category3:
              trackedData?.costUnitAddress ?? trackedData?.address ?? null, //Apartment "cosUnitAddress" or CostUnits address.
            item_variant: trackedData?.apartment_type ?? null, //Only if object is apartment
            quantity: 1,
          },
        ],
      },
      kieli: trackedData.pll_current_language,
    };
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push(dataLayerObject);
  };

  const generateAnalyticsSearchDone = (trackedData = {}) => {
    const dataLayerObject = {
      event: "asuntohaku",
      alueet: trackedData.locations ? trackedData.locations.join(", ") : null,
      maxvuokra: trackedData.rent ?? null,
      valinnat: trackedData.extraInfos
        ? trackedData.extraInfos.join(", ")
        : null,
      hintaluokka: trackedData.priceLevels
        ? trackedData.priceLevels.join(", ")
        : null,
      vaihtari: trackedData.exchangeStudents ?? "ei",
    };

    dataLayer.push(dataLayerObject);
  };

  return {
    generateAnalyticsAddToCart: (trackedData) =>
      validate(trackedData, generateAnalyticsAddToCart),
    generateAnalyticsSearchDone: (trackedData) =>
      validate(trackedData, generateAnalyticsSearchDone),
  };
};

export default analyticsApi;
